const shopMap = document.querySelector('.shop-map');

if (shopMap) {
  let currentCategory = 'all';
  const filterButtons = document.querySelectorAll('.shop-map__filter-btn');
  const shopSvgAreas = document.querySelectorAll('.map-svg__path');
  const categoryFilters = document.querySelectorAll('.shop-map .dropdown__list-item input');

  let tooltipHideTimeout = null;

  // Clear shop info
  const resetActiveShops = () => {
    if (tooltipHideTimeout) {
      clearTimeout(tooltipHideTimeout);
      tooltipHideTimeout = null;
    }
    document
      .querySelectorAll('.map-svg__popup-item.active, .map-svg__path.active')
      .forEach((info) => info.classList.remove('active'));
  };

  // Show tooltip for a shop number
  // persistent: skip auto-hide (used by activateFromUrl deep-link)
  const toggleTooltip = (shopNumber, shopFloor = 'first-floor', persistent = false) => {
    if (tooltipHideTimeout) {
      clearTimeout(tooltipHideTimeout);
      tooltipHideTimeout = null;
    }

    document.querySelector('.map-svg__popup-item.active')?.classList.remove('active');
    document.querySelector('.map-svg__path.active')?.classList.remove('active');

    const targetPopup = document.querySelector(
      `.map-svg__popup [data-popup="${shopNumber}"][data-floor="${shopFloor}"]`,
    );
    const targetSvgArea = document.querySelector(
      `.map-svg__path[data-shop="${shopNumber}"][data-floor="${shopFloor}"]`,
    );

    targetPopup?.classList.add('active');
    targetSvgArea?.classList.add('active');

    if (!persistent && windowWidth() > breakpointMd) {
      tooltipHideTimeout = setTimeout(() => {
        targetPopup?.classList.remove('active');
        targetSvgArea?.classList.remove('active');
        tooltipHideTimeout = null;
      }, 3000);
    }
  };

  // Shop hover
  [...shopSvgAreas, ...filterButtons].forEach((el) =>
    el.addEventListener('mouseover', () => {
      const shopNumber = el.getAttribute('data-shop');
      const shopFloor = el.getAttribute('data-floor');

      if (shopNumber) {
        toggleTooltip(shopNumber, shopFloor);
      }
    }),
  );

  // Filter shops by category
  const filterShops = (category) => {
    const activeMap = document.querySelector('.map-svg__floor.active');
    if (!activeMap) return;

    const activeFloor = activeMap.getAttribute('data-floor');

    // Hide all shop info
    resetActiveShops();

    [...filterButtons, ...shopSvgAreas].forEach((area) => {
      const shopCategory = area.getAttribute('data-category');
      const shopFloors = area.getAttribute('data-floor').split(',');
      const visible = (category === 'all' || shopCategory === category) && shopFloors.includes(activeFloor);
      area.classList.toggle('is-hidden', !visible);
    });
  };

  // Filter shops based on the active floor
  const filterShopsByActiveFloor = () => {
    const activeMap = document.querySelector('.map-svg__floor.active');
    const activeFloor = activeMap.getAttribute('data-floor');

    filterButtons.forEach((shop) => {
      const shopFloors = shop.getAttribute('data-floor').split(',');
      shop.classList.toggle('is-hidden', !shopFloors.includes(activeFloor));
    });
  };

  // Init category filter listeners
  categoryFilters.forEach((filterItem) =>
    filterItem.addEventListener('change', () => {
      currentCategory = filterItem.getAttribute('data-category');
      filterShops(currentCategory);
    }),
  );

  // Toggle tab
  attachEvent('.shop-map__tab-btn', 'click', (el) => {
    const floor = el.target.getAttribute('data-floor');
    // Remove active class from all maps and switches
    document
      .querySelectorAll('.map-svg__floor.active, .shop-map__tab-btn.active')
      .forEach((el) => el.classList.remove('active'));

    // Add active class to the selected floor map and switch
    document.querySelector(`.map-svg__floor[data-floor="${floor}"]`).classList.add('active');
    el.target.classList.add('active');

    // Hide all shop info
    resetActiveShops();

    // Update visible shops based on selected floor
    filterShopsByActiveFloor();

    // Re-apply the current category filter on new floor
    filterShops(currentCategory);
  });

  attachEvent('.map-svg__floor a', 'click', (el) => {
    if (windowWidth() < breakpointMd) {
      el.preventDefault();
    }
  });

  // Deep-link from URL: #floor-label + ?shop=id
  // Supports both ?shop=ID#prvo-nadstropje and #prvo-nadstropje?shop=ID
  const activateFromUrl = () => {
    const rawHash = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    const [hashPath, hashQuery = ''] = rawHash.split('?');
    const floorLabel = hashPath.toLowerCase();
    const shopId =
      new URLSearchParams(window.location.search).get('shop') || new URLSearchParams(hashQuery).get('shop');

    if (!floorLabel && !shopId) return;

    if (floorLabel) {
      const floorBtn = [...shopMap.querySelectorAll('.shop-map__tab-btn')].find(
        (btn) => btn.getAttribute('data-floor-label')?.toLowerCase() === floorLabel,
      );

      if (floorBtn && !floorBtn.classList.contains('active')) {
        floorBtn.click();
      }
    }

    if (shopId) {
      const shopEl = [...shopMap.querySelectorAll('[data-shop]')].find(
        (el) => el.getAttribute('data-shop')?.toLowerCase() === shopId.toLowerCase(),
      );

      if (shopEl) {
        const shopNumber = shopEl.getAttribute('data-shop');
        const shopFloor = shopEl.getAttribute('data-floor')?.split(',')[0];
        const floorBtn = shopMap.querySelector(`.shop-map__tab-btn[data-floor="${shopFloor}"]`);

        if (floorBtn && !floorBtn.classList.contains('active')) {
          floorBtn.click();
        }

        // Keep highlight visible until user hovers another shop
        toggleTooltip(shopNumber, shopFloor, true);
      }
    }

    const section = shopMap.closest('.sc-shop-map') || shopMap;
    const top = section.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  activateFromUrl();
}
